const translations = {
  modalTitle: 'New automation',
  modalTitle_edit: 'Editing automation',
  modalTitle_cloning: 'Cloning automation',
  'entities.undefined': '___',
  'entities.serviceOrder': 'activity',
  'entities.checklist': 'questionnaire',
  'entities.place': 'place',
  'entities.person': 'person',
  'entities.fleet': 'fleet',
  'entities.user': 'user',
  'entities.nonCompliance': 'non compliance',
  'status.all': 'All',
  'status.request': 'Request',
  'status.open': 'Open',
  'status.received': 'Received',
  'status.accept': 'Accepted',
  'status.refused': 'Refused',
  'status.execution': 'Execution',
  'status.pause': 'Paused',
  'status.unproductive': 'Unproductive',
  'status.completed': 'Completed',
  'status.pending': 'Pending',
  'status.canceled': 'Canceled',
  'status.approved': 'Approved',
  'status.disapproved': 'Disapproved',
  'status.resolved': 'Resolved',
  'status.unresolved': 'Unresolved',
  'status.actionPlan': 'Action Plan',
  'status.request_plural': 'Requests',
  'status.open_plural': 'Open',
  'status.received_plural': 'Received',
  'status.accept_plural': 'Accepted',
  'status.refused_plural': 'Refused',
  'status.execution_plural': 'Executions',
  'status.pause_plural': 'Paused',
  'status.unproductive_plural': 'Unproductives',
  'status.completed_plural': 'Completed',
  'status.pending_plural': 'Pending',
  'status.canceled_plural': 'Canceled',
  'status.approved_plural': 'Approved',
  'status.disapproved_plural': 'Disapproved',
  'status.resolved_plural': 'Resolved',
  'status.unresolved_plural': 'Unresolved',
  'status.actionPlan_plural': 'Action Plans',
  'status.done': 'Completed',
  'status.ignored': 'Ignored',
  'status.ignored_plural': 'Ignored',
  'status.inProgress': 'In Progress',
  'status.inProgress_plural': 'In Progress',
  'status.done': 'Completed',
  'status.ignored': 'Ignored',
  'status.ignored_plural': 'Ignored',
  'status.inProgress': 'In Progress',
  'status.inProgress_plural': 'In Progress',
  'status.closing': 'Closing',
  'status.closing_plural': 'Closings',
  'status.true': 'Yes',
  'status.false': 'No',
  'events.undefined': '___',
  'events.create': 'created',
  'events.update': 'updated',
  'events.delete': 'removed',
  'events.reply': 'answered',
  'actions.undefined': '___',
  'actions.insert_service_order': 'create a new activity',
  'actions.insert_service_orders': 'create multiple activities',
  'actions.complete_service_orders': 'complete open activities',
  'actions.complete_non_compliances': 'complete open non-compliances',
  'actions.schedule_insert_service_order': 'schedule a new activity',
  'actions.schedule_insert_service_orders': 'schedule multiple activities',
  'actions.createNonCompliance': 'create non-compliance',
  'actions.action': 'action',
  'actions.createActionPlan': 'create action plan',
  'actions.webhook': 'call external api',
  'actions.notify': 'send email',
  'replyTypes.undefined': '___',
  'replyTypes.nonCompliance': 'non compliance',
  'replyTypes.text': 'text',
  'replyTypes.number': 'number',
  'webhook.addNew': 'Add new Header',
  'webhook.authorization': 'authorization',
  'webhook.workspace': 'workspace',
  'webhook.key': 'Key',
  'webhook.value': 'Value',
  'fields.group_id': 'group responsible for the activity',
  'fields.user.contract.group_id': 'responsible user group',
  name: 'Name',
  readOnly: 'Read only',
  enabled: 'Enabled',
  quantity: 'Quantity',
  title: 'Automations',
  new: 'New Automation',
  bulkRegistration: 'Bulk registration',
  serviceOrdersCount: '{{count}} activity',
  serviceOrdersCount_plural: '{{count}} activities',
  dynamicFields: 'dynamic fields',
  content: 'Content',
  'fields.name': 'Name',
  'fields.email': 'Email',
  'fields.profile': 'Profile',
  'fields.checklist': 'Questionnaire*',
  'fields.destinationType': 'Destination type',
  'fields.destination': 'Destination*',
  'fields.asset': 'Asset',
  'fields.responsible': 'Responsible',
  'fields.scheduling': 'Scheduling',
  'fields.bond': 'Bond',
  'fields.type': 'Type',
  'fields.description': 'Description',
  'fields.metadata': 'Metadata',
  'fields.placePerson': 'Place/Person*',
  'fields.schedulingDate': 'Scheduling date',
  'fields.user': 'User',
  updatePlaceData: 'Update place data',
  fieldsWithoutValueNotChanged: 'Fields without value will not be changed.',
  addPlaceTypeCondition: 'To change additional fields, add the place type condition in the automation.',
  fillAtLeastOneField: 'Fill at least one field.',
  'googleCalendar.eventTitle': 'Event title',
  'googleCalendar.description': 'Description',
  'googleCalendar.startsAt': 'Starts at',
  'googleCalendar.duration': 'Event duration',
  'googleCalendar.durationOptions.15': 'Fifteen minutes',
  'googleCalendar.durationOptions.30': 'Half hour',
  'googleCalendar.durationOptions.60': 'One hour',
  'googleCalendar.durationOptions.90': 'One hour and a half',
  'googleCalendar.durationOptions.120': 'Two hours',
  'googleCalendar.durationOptions.150': 'Two and a half hours',
  'googleCalendar.durationOptions.180': 'Three hours',
  'googleCalendar.durationOptions.210': 'Three and a half hours',
  'googleCalendar.durationOptions.240': 'Four hours',
  'googleCalendar.emailReminder': 'Email reminder before event (in minutes)',
  'd4sign.signers': 'signers',
  'd4sign.signersRequired': 'Signers*',
  'd4sign.documentName': 'Document name',
  'd4sign.safe': 'Safe*',
  'd4sign.folderOptional': 'Folder (optional)',
  'd4sign.document': 'Document*',
  'd4sign.configureSigners': '+ Configure Signers',
  'd4sign.sequentialSignature': 'Use sequential signature (optional)',
  'd4sign.emailRequired': 'Email*',
  'd4sign.actionRequired': 'Action*',
  'd4sign.configureDocumentSending': 'Configure document sending',
  'd4sign.publicTokenForWebhook': 'Public token for webhook',
  'actions.originActivity': 'origin activity',
  minimumOneRecord: 'Minimum of 1 record',
  selectAtLeastOneLevel: 'Select at least one level',
  invalidPayload: 'Invalid payload',
  triggerCannotBeEdited: 'Trigger cannot be edited',
  'actions.insert_service_order': 'create a new activity',
  'actions.insert_service_orders': 'create several activities',
  'actions.complete_service_orders': 'complete open activities',
  'actions.complete_non_compliances': 'complete open non-compliances',
  'actions.update_service_order_name': 'update activity name',
  'actions.insert_user': 'create a new user',
  'actions.insert_place': 'create a new place/person',
  'actions.webhook': 'call external api',
  'actions.email': 'send an email',
  'actions.update_service_order_user_or_group': 'update activity user or group',
  'actions.slack_channel_message': 'send a message on slack',
  'actions.slack_direct_message': 'send a DM via slack',
  'actions.google_calendar_insert_event': 'create a calendar event',
  'actions.d4sign_send_to_sing': 'send a document',
  'actions.d4sign_attach_document': 'attach a document',
  'actions.d4sign_gen_pdf_and_send_to_sing': 'generate PDF and send',
  'actions.whatsapp_by_twilio': 'send a Whatsapp via Twilio',
  'actions.whatsapp_by_chat_pro': 'send a Whatsapp via ChatPro',
  'chatPro.dynamicNumber': 'dynamic',
  'actions.sms_by_twilio': 'send an SMS via Twilio',
  'actions.place_lock': 'Disable activity opening for non-compliance place using questionnaire',
  'actions.set_availability_status': 'Change Place Availability Status',
  'actions.update_place': 'update activity place',
  'actions.update_asset': 'update asset place',
  'actions.update_status': 'update activity status',
  'actions.assign_tag': 'assign a tag to the activity',
  'actions.remove_tag': "remove the activity's tag",
  'actions.update_parent_status': 'update parent activity status',
  'actions.update_child_service_order': 'Update Activity',
  'templates.onCompleteActivitySendEmail': 'When completing an activity, send an email',
  'templates.onCompleteActivityCallExternalApi': 'When completing an activity, call an external api',
  'templates.onCompleteActivitySendSlackMessage': 'When completing an activity, send a slack message',
  'templates.onCompleteActivitySendDocumentToSign': 'When completing an activity, send a document to be signed',
  'templates.onCompleteActivityAttachDocument': 'When completing an activity, attach a document to origin',
  'templates.onCompleteActivitySendWhatsappTwilio': 'When completing an activity, send a whatsapp via twilio',
  'templates.onCompleteActivitySendSmsTwilio': 'When completing an activity, send an sms via twilio',
  'templates.onCompleteActivitySendWhatsappChatPro': 'When completing an activity, send a whatsapp via ChatPro',
  'templates.onCreateActivityCreateGoogleCalendarEvent': 'When creating an activity, create a google calendar event',
  'templates.onCompleteActivityCreateNewActivity': 'When completing an activity, create a new activity',
  'templates.onCreateActivityCreateAnotherActivity': 'When creating an activity, create another activity',
  'templates.onCreateUserSendEmail': 'When creating a user, send an email',
  'templates.onCreateUserCallExternalApi': 'When creating a user, call an external api',
  'templates.onCreateUserCreateActivity': 'When creating a user, create an activity',
  'templates.onReplyFormSendEmail': 'When replying to a form, send an email',
  'templates.onReplyFormCallExternalApi': 'When replying to a form, call an external api',
  'templates.onReplyFormCreateActivity': 'When replying to a form, create an activity',
  'templates.onCreateNonComplianceInstanceSendEmail': 'When creating a new non-compliance instance, send an email',
  'templates.onCreateNonComplianceInstanceCallExternalApi':
    'When creating a new non-compliance instance, call an external api',
  'templates.onCreateNonComplianceInstanceCreateActivity':
    'When creating a new non-compliance instance, create an activity',
  'templates.onCreateFormsNonComplianceInstanceSendEmail': 'When creating a new non-compliance instance, send an email',
  'templates.onCreateFormsNonComplianceInstanceCallExternalApi':
    'When creating a new non-compliance instance, call an external api',
  'templates.onCreateFormsNonComplianceInstanceCreateActivity':
    'When creating a new non-compliance instance, create an activity',
  'templates.onCreatePlaceTypeSendEmail': 'When creating a {{placeType}}, send an email',
  'templates.onCreatePlaceTypeCallExternalApi': 'When creating a {{placeType}}, call an external api',
  'templates.onCreatePlaceTypeCreateActivity': 'When creating a {{placeType}}, create an activity',
  'templates.createCustomAutomation': 'Create a custom automation',
  'templates.createNew': 'Create new',
  'templates.useTemplate': 'Use template',
  'baseSentence.whenActivityCreated': 'When an activity is created',
  'baseSentence.whenActivityUpdated': 'When an activity is updated',
  'baseSentence.whenActivityCreatedOrUpdated': 'When an activity is created or updated',
  'baseSentence.whenActivityStatusChanged': 'When an activity status changes',
  'baseSentence.whenActivityTagAssigned': 'When an activity receives a tag',
  'baseSentence.whenActivityTagRemoved': 'When an activity loses its tag',
  'baseSentence.whenNonComplianceEventCreated': 'when a non-compliance event is created',
  'baseSentence.whenNonComplianceGroupCreated': 'when a non-compliance group is created',
  'baseSentence.whenFormReplied': 'when a form is replied',
  'baseSentence.whenReplyEdited': 'When a reply is edited',
  'baseSentence.whenPlaceTypeCreated': 'When a {{placeType}} is created',
  'baseSentence.whenPlaceTypeUpdated': 'When a {{placeType}} is updated',
  'baseSentence.whenPlaceTypeCreatedOrUpdated': 'When a {{placeType}} is created or updated',
  'completeServiceOrders.moreThanDays': 'more than {{days}} days; ',
  'completeServiceOrders.withChecklists': ' with questionnaires {{checklists}}; ',
  'completeServiceOrders.shouldFireAutomations': 'Should fire automations.',
  'completeServiceOrders.configureAutomationBehavior': 'Configure this automation behavior.',
  'completeServiceOrders.moreThanDaysLabel': 'more than (in days)',
  'completeServiceOrders.fireAutomations': 'Fire automations.',
  'completeNonCompliances.moreThan': 'more than ',
  'completeNonCompliances.days': 'days',
  'updateStatus.to': 'to ',
  'assignTag.to': 'with tag ',
  'assignTag.tag': 'Tag',
  'updateStatus.status': 'Status',
  'updateServiceOrderUserOrGroup.user': 'user: {{name}}',
  'updateServiceOrderUserOrGroup.group': 'group: {{name}}',
  'updateServiceOrderUserOrGroup.groups': 'groups',
  'updateServiceOrderUserOrGroup.withThe': 'with the',
  'updateServiceOrderUserOrGroup.withTheGroups': 'with the',
  'typeSelect.actionPlan': 'Action plan',
  'typeSelect.activity': 'Activity',
  'fieldsSection.additionalFields': 'Additional fields',
  'fieldsSection.addFile': 'Add File',
  'lockPlace.disablePlaceForNonCompliance': 'Disable place for non-compliance',
  'lockPlace.reasonRequired': 'Reason*',
  'insertPlace.typeRequired': 'Type*',

  actionNotAllowedForTrigger: 'This action is not available for this trigger',
  'updateChildServiceOrder.nothingToChange': 'Select at least one piece of data to update on the activity',
  'updateChildServiceOrder.actionLabel.current': 'Update current Activity',
  'updateChildServiceOrder.actionLabel.child': 'Update Child Activity',
  'updateChildServiceOrder.target': 'Which activity to update',
  'updateChildServiceOrder.target.current': 'Current activity (the one that triggered the automation)',
  'updateChildServiceOrder.target.child': 'Linked child activity',
  'updateChildServiceOrder.targetHelp.current':
    'The activity that triggered the automation itself is updated (no new activity is created). If someone has it open on screen, what is saved afterwards may overwrite the change made by the automation.',
  'updateChildServiceOrder.targetHelp.child':
    'The child activity linked to the activity that triggered the automation is updated.',
  'updateChildServiceOrder.status': 'Status',
  'updateChildServiceOrder.fieldsHelpCurrent':
    'Only the additional fields filled in here are updated on the activity. Its other additional fields are kept as they are.',
  'updateChildServiceOrder.documentsHelpCurrent':
    'The chosen documents are added to the activity. The documents it already has are kept.',
  'updateChildServiceOrder.with': 'with the data ',
  'updateChildServiceOrder.description': 'Description',
  'updateChildServiceOrder.place': 'Place',
  'updateChildServiceOrder.scheduling': 'Scheduling date',
  'updateChildServiceOrder.checklists': 'Which child activities to update',
  'updateChildServiceOrder.checklistsHelp':
    'Applies to the child activity linked to the chosen questionnaire. If the activity has only one linked child activity, this field can be left blank (it is used automatically); it is only needed when there is more than one.',
  'updateChildServiceOrder.name': 'Name',
  'updateChildServiceOrder.user': 'Responsible',
  'updateChildServiceOrder.asset': 'Asset',
  'updateChildServiceOrder.priority': 'Priority',
  'updateChildServiceOrder.address': 'Address',
  'updateChildServiceOrder.metadata': 'Metadata',
  'updateChildServiceOrder.tag': 'Tag',
  'updateChildServiceOrder.documents': 'Documents',
  'updateChildServiceOrder.documentsHelp':
    'The chosen documents are added to the child activity. The documents it already has are kept.',
  'updateChildServiceOrder.fieldsHelp':
    'Only the additional fields filled in here are updated on the child activity. Its other additional fields are kept as they are.',
  'updateChildServiceOrder.dependentHelp':
    'Only child activities linked to the parent activity as dependent are updated (the parent activity stays pending until the child is completed).'
}

export default translations
